export default __webpack_public_path__ + "static/media/auth-bg-shape.45ac4786.svg";